var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-icon tt-next-day-icon"},[_c('img',{attrs:{"src":require("@/assets/icons-new/clock-square.svg"),"alt":"next-day"}}),_c('div',{staticClass:"tt-tooltip"},[_vm._v(" "+_vm._s(_vm.$t('main_vpopup_next_day_tooltip'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }